<ng-container *ngIf="sign">
  <div class="flex-col center-container" style="margin-top: 15px">
    <div class="flex-row fields-row" style="margin-bottom: 12px">
      <!-- top row, left column -->
      <div class="flex-row fields-container product-fields">
        <div class="flex-column">
          <div class="flex-row field-input">
            <label>Type</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.type"
                [compareWith]="compareSignType"
                (ngModelChange)="onTypeChange()"
              >
                <mat-option
                  *ngFor="let option of signTypeChoices"
                  [value]="option"
                >
                  {{ option ? option.label : 'Niet ingevuld' }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-row field-input">
            <label>Afmetingen</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.signMeasurements"
                [compareWith]="compareSignMeasurements"
              >
                <mat-option
                  *ngFor="let option of signMeasurementsChoices"
                  [value]="option"
                >
                  <ng-container *ngIf="option; else notSelected">
                    {{ option.width }} x {{ option.height }}
                  </ng-container>
                  <ng-template #notSelected> 'Niet ingevuld'</ng-template>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-row field-input">
            <label>Drukwijze</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.pressType"
                [compareWith]="comparePressType"
              >
                <mat-option
                  *ngFor="let option of pressTypeChoices"
                  [value]="option"
                >
                  {{ option ? option.label : 'Niet ingevuld' }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="flex-column" style="padding-left: 6.5em">
          <div class="flex-row field-input">
            <label>Aantal kleuren</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.nbColors"
              >
                <mat-option
                  *ngFor="let option of nbColorsChoices"
                  [value]="option"
                >
                  {{
                    option === null
                      ? 'Niet ingevuld'
                      : option === 5
                      ? 'Full color'
                      : option
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-row field-input">
            <label>Materiaal</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.material"
                [disabled]="sign.type === null"
              >
                <mat-option
                  *ngFor="let option of materialChoices"
                  [value]="option.key"
                >
                  {{ option.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="flex-row field-input">
            <label>Drukwerk ID</label>
            <div class="print-production-info">
              <span>{{ sign.printProduction?.id }}</span>
              <mat-icon
                aria-hidden="false"
                aria-label="view details"
                fontIcon="visibility"
                class="visibility-icon"
                [class.disabled]="!sign.printProduction"
                (click)="sign.printProduction && displayPrintProductionInfo()"
              ></mat-icon>
            </div>
          </div>
          <div class="flex-row no-stock-check">
            <mat-checkbox
              [(ngModel)]="sign.displayPrices"
              [labelPosition]="'before'"
            >
              Prijzen tonen
            </mat-checkbox>
          </div>
        </div>
        <!--        <div class="flex-row no-stock-check">-->
        <!--          <mat-checkbox-->
        <!--            [(ngModel)]="sign.displayPrices"-->
        <!--            [labelPosition]="'before'"-->
        <!--          >-->
        <!--            Zonder voorraad-->
        <!--          </mat-checkbox>-->
        <!--        </div>-->
      </div>
      <!-- top row, right column -->
      <div class="flex-col fields-container">
        <div class="cluster-container mb-5">
          <div class="flex-row field-input">
            <label>Kapvorm</label>
            <conditional-description
              [(ngModel)]="sign.specialShape"
              (ngModelChange)="onSpecialShapeChange()"
            ></conditional-description>
          </div>
        </div>

        <div class="cluster-container mb-5">
          <div class="flex-row field-input">
            <label>Reflecterend</label>
            <conditional-description
              [(ngModel)]="sign.reflectable"
            ></conditional-description>
          </div>
        </div>

        <div class="cluster-container">
          <div class="flex-row field-input">
            <label>Aflopend</label>
            <mat-form-field appearance="outline">
              <mat-select
                matInput
                placeholder="Maak een keuze"
                [(ngModel)]="sign.descending"
              >
                <mat-option [value]="null">Niet ingevuld</mat-option>
                <mat-option [value]="true">Ja</mat-option>
                <mat-option [value]="false">Nee</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row not-full fields-row" style="margin-bottom: 12px">
      <!-- mid row, left column -->
      <div class="flex-col fields-container">
        <div class="flex-row field-input list">
          <div class="flex-col" style="margin-top: 17px; width: 25%">
            <label>Bedrijven</label>
            <div class="flex-row">
              <mat-icon
                svgIcon="add"
                class="pull-left clickable"
                (click)="addParticipatingCompany()"
              ></mat-icon>
            </div>
          </div>
          <div class="flex-col" style="width: 75%">
            <ng-container
              *ngIf="sign.participatingCompanies != null; else emptyMessage"
            >
              <div class="companies-list-container">
                <div
                  class="flex-row"
                  *ngFor="let pc of sign.participatingCompanies; index as i"
                >
                  <participating-company-edit
                    [participatingCompany]="pc"
                    (itemRemoved)="removeParticipatingCompanyAt(i)"
                    style="width: 100%"
                  >
                  </participating-company-edit>
                </div>
              </div>
            </ng-container>
            <ng-template #emptyMessage>
              Geen bedrijven geselecteerd
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Upper row, middle column -->
      <div class="flex-col fields-container">
        <div class="flex-row field-input">
          <label>Titel</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.title" />
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Telefoonnummer</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.phoneNumber" />
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Oriëntatie</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.shape"
              [compareWith]="compareShapeType"
            >
              <mat-option
                *ngFor="let option of shapeTypeChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Links/Rechts</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.position"
              [compareWith]="comparePositionType"
            >
              <mat-option
                *ngFor="let option of positionTypeChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <br />
        <div class="flex-row no-stock-check">
          <mat-checkbox
            [(ngModel)]="sign.withoutStock"
            [labelPosition]="'before'"
          >
            Zonder voorraad
          </mat-checkbox>
        </div>

        <div *ngIf="sign.withoutStock" class="flex-row field-input">
          <label>Prijs bord</label>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix>euro_symbol</mat-icon>
            <input
              [(ngModel)]="sign.singleBoardPrice"
              class="text-right"
              matInput
              mask="0*,00"
            />
          </mat-form-field>
        </div>
      </div>

      <!-- Upper row, right column -->
      <div class="flex-col fields-container">
        <sign-detail-examples
          [sign]="sign"
          style="margin-bottom: 30px"
        ></sign-detail-examples>

        <div *ngIf="!sign.withoutStock" class="flex-row field-input">
          <label>
            Standaard locatie
            <mat-icon
              [matTooltip]="
                'Indien de hier ingegeven locatie nog niet bestaat, zal deze worden aangemaakt bij opslaan'
              "
            >
              info
            </mat-icon>
          </label>
          <div class="flex-row location-input-row">
            <mat-form-field appearance="outline">
              <mat-label>Rek</mat-label>
              <input
                type="number"
                matInput
                [(ngModel)]="sign.defaultLocation.rack"
              />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Schap</mat-label>
              <input matInput [(ngModel)]="sign.defaultLocation.shelf" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Vak</mat-label>
              <input
                type="number"
                matInput
                [(ngModel)]="sign.defaultLocation.compartment"
              />
            </mat-form-field>
          </div>
        </div>

        <div *ngIf="!sign.withoutStock" class="flex-row field-input">
          <label>Minimum voorraad</label>
          <mat-form-field appearance="outline">
            <input
              class="red-text"
              type="number"
              matInput
              [(ngModel)]="sign.minimumStock"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex-row not-full fields-row">
      <!-- Bottom row, left column -->
      <div class="flex-col fields-container">
        <div class="flex-row field-input">
          <label>Kleur 1</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.colorOne" />
          </mat-form-field>
        </div>
        <div class="flex-row field-input">
          <label>Kleur 2</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.colorTwo" />
          </mat-form-field>
        </div>
        <div class="flex-row field-input">
          <label>Kleur 3</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.colorThree" />
          </mat-form-field>
        </div>
        <div class="flex-row field-input">
          <label>Kleur 4</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.colorFour" />
          </mat-form-field>
        </div>
      </div>

      <!-- Bottom row, middle column -->
      <div class="flex-col fields-container">
        <div class="flex-row field-input">
          <label>Frame</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.frame"
              (ngModelChange)="onFrameChange()"
              [compareWith]="compareFrame"
            >
              <mat-option *ngFor="let option of frameChoices" [value]="option">
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row field-input" [hidden]="hideFrameColorSelect">
          <label>Frame kleur</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.frameColor"
              [compareWith]="compareFrameColor"
            >
              <mat-option
                *ngFor="let option of frameColorChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div
          class="flex-row field-input"
          [ngClass]="{ 'double-height': sign.pairedWithSelf === false }"
        >
          <label>Bord koppeling</label>
          <div class="flex-col" style="width: 180px">
            <div class="flex-row field-input">
              <mat-form-field appearance="outline">
                <mat-select
                  matInput
                  placeholder="Niet gekoppeld"
                  [(ngModel)]="sign.pairedWithSelf"
                  (ngModelChange)="onPairedWithSelfChanged()"
                >
                  <mat-option [value]="null">Niet gekoppeld</mat-option>
                  <mat-option [value]="false"
                    >Gekoppeld met ander bord
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              *ngIf="sign.pairedWithSelf === false"
              class="flex-row field-input"
            >
              <ng-container
                *ngIf="atleastOneCompanySelected(); else companiesRequired"
              >
                <sign-from-company-picker [sign]="sign">
                </sign-from-company-picker>
              </ng-container>
              <ng-template #companiesRequired>
                Gelieve eerst minstens één bedrijf te selecteren
              </ng-template>
            </div>
          </div>
        </div>

        <div class="flex-row field-input">
          <label>Kleur palen</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.poleColor"
              [compareWith]="comparePoleColor"
            >
              <mat-option
                *ngFor="let option of poleColorChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Tekst font</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.textFont" />
          </mat-form-field>
        </div>
      </div>

      <!-- Bottom row, right column -->
      <div class="flex-col fields-container">
        <div class="flex-row field-input">
          <label>Tekst type</label>
          <mat-form-field appearance="outline">
            <mat-select
              matInput
              placeholder="Maak een keuze"
              [(ngModel)]="sign.textType"
              [compareWith]="compareTextType"
            >
              <mat-option
                *ngFor="let option of textTypeChoices"
                [value]="option"
              >
                {{ option ? option.label : 'Niet ingevuld' }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Afmetingen</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.textMeasurements" />
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Kleur tekst</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.textColors" />
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Kleur achtergrond</label>
          <mat-form-field appearance="outline">
            <input matInput [(ngModel)]="sign.backgroundColor" />
          </mat-form-field>
        </div>

        <div class="flex-row field-input">
          <label>Tekst prijs</label>
          <mat-form-field appearance="outline">
            <mat-icon matPrefix>euro_symbol</mat-icon>
            <input
              [(ngModel)]="sign.textPrice"
              class="text-right"
              matInput
              mask="0*,00"
            />
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="flex-row fields-row finished-checkbox-outer-container">
      <div class="flex-col finished-checkbox-inner-container red-text">
        <mat-checkbox
          [(ngModel)]="sign.graphicsFinished"
          [labelPosition]="'before'"
        >
          Grafisch afgewerkt
        </mat-checkbox>
        <mat-checkbox
          [(ngModel)]="sign.signComplete"
          [labelPosition]="'before'"
        >
          Admin check
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="sign.oldLayout" [labelPosition]="'before'">
          Oude lay-out
        </mat-checkbox>
      </div>
    </div>

    <div class="flex-row fields-row" style="margin-top: 15px">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Opmerkingen</mat-label>
        <textarea matInput [(ngModel)]="sign.remarks"></textarea>
      </mat-form-field>
    </div>

    <div class="flex-col fields-row" style="margin-top: 15px">
      <div class="flex-row important-info-title">
        <label
          ><b>Belangrijke info over dit voorraadbord.</b> (Per afdeling)</label
        >
      </div>

      <div class="d-flex">
        <div class="department-checkbox">
          <div class="small-upper-space">
            <mat-checkbox [(ngModel)]="sign.immoValue">Immo</mat-checkbox>
          </div>
        </div>
        <div class="department-info">
          <textarea-input
            [initContent]="sign.immoInfo"
            [placeholder]="''"
            (answer)="immoInfoChange($event)"
          ></textarea-input>
        </div>
      </div>

      <div class="d-flex">
        <div class="department-checkbox">
          <div class="small-upper-space">
            <mat-checkbox [(ngModel)]="sign.graphicalValue"
              >Grafische
            </mat-checkbox>
          </div>
        </div>
        <div class="department-info">
          <textarea-input
            [initContent]="sign.graphicalInfo"
            [placeholder]="''"
            (answer)="graphicalInfoChange($event)"
          ></textarea-input>
        </div>
      </div>

      <div class="d-flex">
        <div class="department-checkbox">
          <div class="small-upper-space">
            <mat-checkbox [(ngModel)]="sign.studioValue">Atelier</mat-checkbox>
          </div>
        </div>
        <div class="department-info">
          <textarea-input
            [initContent]="sign.studioInfo"
            [placeholder]="''"
            (answer)="studioInfoChange($event)"
          ></textarea-input>
        </div>
      </div>

      <div class="d-flex">
        <div class="department-checkbox">
          <div class="small-upper-space">
            <mat-checkbox [(ngModel)]="sign.installerValue"
              >Installateur
            </mat-checkbox>
          </div>
        </div>
        <div class="department-info">
          <textarea-input
            [initContent]="sign.installerInfo"
            [placeholder]="''"
            (answer)="installerInfoChange($event)"
          ></textarea-input>
        </div>
      </div>
    </div>

    <div class="flex-row fields-row action-container">
      <button
        *ngIf="sign.id"
        class="btn button archive-button"
        type="button"
        (click)="archive()"
      >
        <span>Verwijderen</span>
      </button>
      <button class="btn btn-main btn-back" type="button" (click)="cancel()">
        Annuleer
      </button>
      <button class="btn button" type="button" (click)="save()">
        <span>Opslaan</span>
      </button>
    </div>
  </div>
</ng-container>
